import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/opportunities/mypage')({
  component: () => <Outlet />,
  staticData: {
    breadcrumbLabel: 'マイページ',
  },
})
